import React from 'react';
import './Skills.css';
import { ProgressBar, Tab, Tabs, Button } from 'react-bootstrap';

const Skills = () => {
  const html = 90;
  const js = 80;
  const react = 70;
  const bootstrap = 85;
  const material = 80;
  const node = 70;
  const express = 65;
  const mongoDB = 60;
  const git = 70;
  const vs = 80;
  const chrome = 70;

  return (
    <>
      <div className="mt-5 text-center progress-div">
        <h1 className="m-2 title">Professional  <span className="title-color">Skills</span></h1>
        <Tabs
          defaultActiveKey="Front-End"
          id="uncontrolled-tab-example">
          <Tab
            eventKey="Front-End"
            title="Front-End">
            <Button
              variant="outline-light"
              size="lg"
              block>
              <ProgressBar
                variant="dark"
                now={html}
                label={`HTML & CSS ${html}%`} />
            </Button>
            <Button
              variant="outline-light"
              size="lg"
              block>
              <ProgressBar
                variant="dark"
                now={js}
                label={`JavaScript ${js}%`} />
            </Button>
            <Button
              variant="outline-light"
              size="lg" block>
              <ProgressBar
                variant="dark"
                now={react}
                label={`React JS ${react}%`} />
            </Button>
            <Button
              variant="outline-light"
              size="lg"
              block>
              <ProgressBar
                variant="dark"
                now={bootstrap}
                label={`BootStrap ${bootstrap}%`} />
            </Button>
            <Button
              variant="outline-light"
              size="lg"
              block>
              <ProgressBar
                variant="dark"
                now={material}
                label={`Material UI ${material}%`} />
            </Button>
          </Tab>
          <Tab eventKey="Back-End" title="Back-End">
            <Button
              variant="outline-light"
              size="lg"
              block>
              <ProgressBar
                variant="dark"
                now={node}
                label={`Node JS ${node}%`} />
            </Button>
            <br />
            <Button variant="outline-light" size="lg" block>
              <ProgressBar
                variant="dark"
                now={express}
                label={`Express JS ${express}%`} />
            </Button>
            <br />
            <Button
              variant="outline-light"
              size="lg" block>
              <ProgressBar
                variant="dark"
                now={mongoDB}
                label={`MongoDB ${mongoDB}%`} />
            </Button>
          </Tab>
          <Tab
            eventKey="Tools"
            title="Tools">
            <Button
              variant="outline-light"
              size="lg"
              block>
              <ProgressBar
                variant="dark"
                now={git}
                label={`Git ${git}%`} />
            </Button>
            <br />
            <Button
              variant="outline-light"
              size="lg" block>
              <ProgressBar
                variant="dark"
                now={vs}
                label={`VS Code ${vs}%`} />
            </Button>
            <br />
            <Button
              variant="outline-light"
              size="lg" block>
              <ProgressBar
                variant="dark"
                now={chrome}
                label={`Chrome Dev Tool ${chrome}%`} />
            </Button>
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default Skills;